export default __webpack_public_path__ + "static/10_37-2ae3089b8f551e47181f1ea1417ce630.png";